/* ========================================
   MAIN PRODUCT - from Lovable products.$slug.tsx
   Size/color select, variant match, qty, add-to-cart AJAX, accordion, gallery dots
   ======================================== */
(function () {
  var root = document.querySelector('[data-product]');
  if (!root) return;

  var productData = {};
  try { productData = JSON.parse(root.getAttribute('data-product-json')); } catch (e) {}
  var variants = productData.variants || [];

  var form = root.querySelector('[data-product-form]');
  var variantInput = root.querySelector('[data-variant-id]');
  var priceEl = root.querySelector('[data-product-price]');
  var stickyPriceEl = root.querySelector('[data-sticky-price]');
  var skuEl = root.querySelector('[data-product-sku]');
  var addBtn = root.querySelector('[data-add-btn]');
  var qtyInput = root.querySelector('[data-qty-input]');
  var qtyValue = root.querySelector('[data-qty-value]');

  var selected = { size: null, color: null };

  // ---------- Option index detection ----------
  var sizeOptIdx = -1, colorOptIdx = -1;
  (productData.options || []).forEach(function (name, i) {
    var dn = String(name).toLowerCase();
    if (dn.indexOf('size') !== -1) sizeOptIdx = i;
    if (dn.indexOf('color') !== -1 || dn.indexOf('colour') !== -1) colorOptIdx = i;
  });

  // ---------- Money format (store currency, set in theme.liquid) ----------
  function formatMoney(cents) {
    if (window.SYNC && window.SYNC.formatMoneyShop) return window.SYNC.formatMoneyShop(cents);
    return '$' + (cents / 100).toFixed(2);
  }

  // ---------- Variant matching ----------
  function findVariant() {
    var match = variants.find(function (v) {
      var okSize = sizeOptIdx === -1 || !selected.size || v.options[sizeOptIdx] === selected.size;
      var okColor = colorOptIdx === -1 || !selected.color || v.options[colorOptIdx] === selected.color;
      return okSize && okColor;
    });
    if (!match && selected.size && sizeOptIdx !== -1) {
      match = variants.find(function (v) { return v.options[sizeOptIdx] === selected.size; });
    }
    return match || variants[0];
  }

  function updateVariant() {
    var v = findVariant();
    if (!v) return;
    if (variantInput) variantInput.value = v.id;
    if (priceEl) priceEl.textContent = formatMoney(v.price);
    if (stickyPriceEl) stickyPriceEl.textContent = formatMoney(v.price);
    if (skuEl) skuEl.textContent = v.sku || '';
    if (addBtn) {
      if (v.available) {
        addBtn.disabled = false;
        addBtn.textContent = 'Add to cart';
      } else {
        addBtn.disabled = true;
        addBtn.textContent = 'Sold out';
      }
    }
  }

  // ---------- Size buttons ----------
  root.querySelectorAll('[data-size-btn]').forEach(function (btn) {
    if (btn.classList.contains('is-active')) selected.size = btn.getAttribute('data-size-value');
    btn.addEventListener('click', function () {
      root.querySelectorAll('[data-size-btn]').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      selected.size = btn.getAttribute('data-size-value');
      updateVariant();
    });
  });

  // ---------- Color buttons ----------
  var colorLabel = root.querySelector('[data-color-label]');
  root.querySelectorAll('[data-color-btn]').forEach(function (btn) {
    if (btn.classList.contains('is-active')) selected.color = btn.getAttribute('data-color-value');
    btn.addEventListener('click', function () {
      root.querySelectorAll('[data-color-btn]').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      selected.color = btn.getAttribute('data-color-value');
      if (colorLabel) colorLabel.textContent = selected.color;
      updateVariant();
    });
  });

  // ---------- Quantity ----------
  var qty = 1;
  function setQty(n) {
    qty = Math.max(1, n);
    if (qtyValue) qtyValue.textContent = qty;
    if (qtyInput) qtyInput.value = qty;
  }
  var minus = root.querySelector('[data-qty-minus]');
  var plus = root.querySelector('[data-qty-plus]');
  if (minus) minus.addEventListener('click', function () { setQty(qty - 1); });
  if (plus) plus.addEventListener('click', function () { setQty(qty + 1); });

  // ---------- Add to cart (AJAX) ----------
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = findVariant();
      if (!v || !v.available) return;
      addBtn.disabled = true;
      var original = addBtn.textContent;
      addBtn.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: v.id, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          addBtn.textContent = original;
          addBtn.disabled = false;
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:open'));
        })
        .catch(function () {
          addBtn.textContent = original;
          addBtn.disabled = false;
        });
    });
  }

  // ---------- Accordions ----------
  root.querySelectorAll('[data-accordion-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var collapsible = btn.nextElementSibling;
      var isOpen = btn.classList.contains('is-open');
      btn.classList.toggle('is-open', !isOpen);
      if (collapsible) collapsible.setAttribute('data-open', String(!isOpen));
    });
  });

  // ---------- Gallery dots (mobile) ----------
  var gallery = root.querySelector('[data-product-gallery]');
  var dots = root.querySelectorAll('.product__dot');
  if (gallery && dots.length) {
    gallery.addEventListener('scroll', function () {
      var idx = Math.round(gallery.scrollLeft / gallery.clientWidth);
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    });
    if (dots[0]) dots[0].classList.add('is-active');
  }

  // ---------- Size guide modal ----------
  var sizeChartBtn = root.querySelector('[data-size-chart-open]');
  var sizeModal = root.querySelector('[data-size-modal]');
  if (sizeChartBtn && sizeModal) {
    var sizeModalClose = sizeModal.querySelectorAll('[data-size-modal-close]');
    function openSizeModal() {
      sizeModal.classList.add('is-open');
      sizeModal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var closeBtn = sizeModal.querySelector('[data-size-modal-close]');
      if (closeBtn) closeBtn.focus();
    }
    function closeSizeModal() {
      sizeModal.classList.remove('is-open');
      sizeModal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      sizeChartBtn.focus();
    }
    sizeChartBtn.addEventListener('click', openSizeModal);
    sizeModalClose.forEach(function (el) { el.addEventListener('click', closeSizeModal); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sizeModal.classList.contains('is-open')) closeSizeModal();
    });
  } else if (sizeChartBtn) {
    // fallback: no modal markup -> old behaviour
    sizeChartBtn.addEventListener('click', function () {
      window.location.href = '/pages/size-chart';
    });
  }

  // ---------- Sticky add to cart ----------
  var stickyBar = root.querySelector('[data-product-sticky]');
  if (stickyBar && addBtn && 'IntersectionObserver' in window) {
    var stickyObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        // Show sticky bar only when the main add button is OUT of view
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        stickyBar.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
      });
    }, { rootMargin: '0px 0px -10px 0px', threshold: 0 });
    stickyObserver.observe(addBtn);
  }

  // init
  updateVariant();
  setQty(1);
})();

/* ========================================
   ENHANCEMENTS (appended, self-contained)
   1) Mobile gallery arrows  ‹ ›  (swipe hint + tap to move)
   2) Smaller sticky Add-to-cart bar on mobile
   Styles injected here so no other file needs editing.
   ======================================== */
(function () {
  var root = document.querySelector('[data-product]');
  if (!root) return;

  // ---- inject styles once ----
  if (!document.getElementById('product-enhance-styles')) {
    var css = ''
      + '.product__nav{position:absolute;top:50%;transform:translateY(-50%);z-index:3;'
      + 'width:2.25rem;height:2.25rem;display:flex;align-items:center;justify-content:center;'
      + 'border:none;border-radius:9999px;background:rgba(var(--color-background),0.55);'
      + 'color:rgb(var(--color-foreground));-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px);'
      + 'cursor:pointer;transition:background-color .2s ease,opacity .2s ease;}'
      + '.product__nav:hover{background:rgba(var(--color-background),0.82);}'
      + '.product__nav:active{transform:translateY(-50%) scale(0.9);}'
      + '.product__nav svg{width:1rem;height:1rem;display:block;}'
      + '.product__nav--prev{left:0.5rem;}'
      + '.product__nav--prev svg{transform:rotate(180deg);}'
      + '.product__nav--next{right:0.5rem;}'
      + '.product__nav[disabled]{opacity:0.25;pointer-events:none;}'
      + '@media (min-width:768px){.product__nav{display:none;}}'
      + '@media (max-width:767px){'
      + '.product__gallery{align-items:flex-start !important;}'
      + '.product__media-item{aspect-ratio:1/1 !important;height:auto !important;padding:0.5rem !important;}'
      + '.product-sticky__inner{padding:0.4rem 0.6rem !important;gap:0.5rem !important;}'
      + '.product-sticky__img{width:34px !important;height:42px !important;}'
      + '.product-sticky__title{font-size:10px !important;letter-spacing:0.1em !important;}'
      + '.product-sticky__price{font-size:10px !important;}'
      + '.product-sticky__btn{padding:0.5rem 1rem !important;font-size:10px !important;letter-spacing:0.12em !important;}'
      + '.product-sticky--rounded{left:0.5rem !important;right:0.5rem !important;}'
      + '.product-sticky--rounded.product-sticky--bottom{bottom:0.5rem !important;}'
      + '}';
    var st = document.createElement('style');
    st.id = 'product-enhance-styles';
    st.textContent = css;
    document.body.appendChild(st);
  }

  // ---- mobile gallery arrows ----
  var gallery = root.querySelector('[data-product-gallery]');
  if (!gallery) return;
  var items = gallery.querySelectorAll('.product__media-item');
  if (items.length < 2) return; // single image: no arrows needed

  var col = gallery.closest('.product__gallery-col') || gallery.parentNode;
  if (getComputedStyle(col).position === 'static') col.style.position = 'relative';

  function makeArrow(kind, label) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'product__nav product__nav--' + kind;
    b.setAttribute('aria-label', label);
    b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" '
      + 'stroke-linecap="round" stroke-linejoin="round"><polyline points="9 6 15 12 9 18"></polyline></svg>';
    return b;
  }

  var prev = makeArrow('prev', 'Previous image');
  var next = makeArrow('next', 'Next image');
  col.appendChild(prev);
  col.appendChild(next);

  function step(dir) {
    gallery.scrollBy({ left: dir * gallery.clientWidth, behavior: 'smooth' });
  }
  prev.addEventListener('click', function () { step(-1); });
  next.addEventListener('click', function () { step(1); });

  function refresh() {
    var max = gallery.scrollWidth - gallery.clientWidth - 2;
    prev.disabled = gallery.scrollLeft <= 2;
    next.disabled = gallery.scrollLeft >= max;
  }
  gallery.addEventListener('scroll', refresh, { passive: true });
  window.addEventListener('resize', refresh);
  refresh();
})();
